<template>
    <form method="get" :action="change_status_route" class="row justify-content-center">
        <input type="hidden" name="_token" v-bind:value="csrf">
        <div class="col-12 col-md-10 col-lg-8">
            <label class="h6 font-weight-bold" for="reason">{{$lang('Proszę podać powód odrzucenia pracy zdalnej:')}}</label>
            <textarea class="form-control mt-2" name="reason" id="reason" v-model="reason"
                      rows="3"></textarea>
            <input type="hidden" name="status_name" v-model="statusName">
            <button type="submit" :disabled="!valid"
                    class="btn btn-primary float-right mt-3">{{ $lang('Zatwierdź powód odrzucenia') }}
            </button>
        </div>
    </form>
</template>

<script>
export default {
    name: "remote-rejection-form",
    props: {
        csrf: String,
        change_status_route: String,
    },
    data() {
        return {
            reason: null,
            statusName: 'NEGATIVE_RESPONSE',
        }
    },
    computed: {
        valid() {
            return (this.reason !== null && this.reason !== '');
        }
    },
}
</script>

<style scoped>

</style>
